import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MarketplaceHeroSlideImageBlockConfig } from '@front-platform/content-builder';
import { marketplaceHeroSlideImageBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface MarketplaceHeroSlideImageBlockRuntimeConfig {}

export type MarketplaceHeroSlideImageBlockConfigInput = Partial<
  Omit<MarketplaceHeroSlideImageBlockConfig, keyof MarketplaceHeroSlideImageBlockRuntimeConfig> &
    MarketplaceHeroSlideImageBlockRuntimeConfig
>;
export type MarketplaceHeroSlideImageBlockResolvedConfig = Omit<
  MarketplaceHeroSlideImageBlockConfig,
  keyof MarketplaceHeroSlideImageBlockRuntimeConfig
> &
  Partial<MarketplaceHeroSlideImageBlockRuntimeConfig>;
export interface MarketplaceHeroSlideImageBlockContract extends ConfigComponentContract<
  MarketplaceHeroSlideImageBlockConfigInput,
  MarketplaceHeroSlideImageBlockResolvedConfig
> {}

@Component({
  selector: 'app-marketplace-hero-slide-image-block',
  templateUrl: './marketplace-hero-slide-image-block.component.html',
  standalone: false,
})
export class MarketplaceHeroSlideImageBlockComponent implements MarketplaceHeroSlideImageBlockContract {
  readonly config = input<MarketplaceHeroSlideImageBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    MarketplaceHeroSlideImageBlockConfig,
    MarketplaceHeroSlideImageBlockRuntimeConfig
  >(marketplaceHeroSlideImageBlockResolveConfig, () => ({ config: this.config() }));
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MarketplaceHeroSlideImageBlockComponent, {
  'keyAliases': {},
});
